import { createListReducer } from './createListReducer';

export const initialState = {
  services: [],
  loading: false,
  error: '',
  order: 'desc',
  orderBy: 'date',
  page: 0,
  rowsPerPage: 25,
  totalServices: 0,
};
export const servicesReducer = createListReducer('services', 'totalServices');